import { sanitize } from '@disco/utils/string-utils'

/**
 * Splits a string by newlines (both \n and \r\n).
 *
 * @param str - The string to split by newlines
 * @returns Array of string segments split by newlines
 */
export const splitByNewlines: (arg1: string) => string[] = str =>
  str.split(/\r?\n/)

/**
 * Converts text with newlines into HTML with proper line breaks.
 *
 * Each line is wrapped in a div tag, and empty lines are converted to <br> tags.
 * The result is sanitized to prevent XSS attacks.
 *
 * @param text - The text to convert to HTML
 * @returns Sanitized HTML string with proper line breaks
 */
export function newlinesAsHtml(text: string): string {
  return sanitize(
    splitByNewlines(text)
      .map(line => (line ? `<div>${line}</div>` : '<br>'))
      .join('\n'),
  )
}
